import {
    EnsConfirmationVia,
    EnsRecipient,
} from '../../../store/features/ens/types';

const CONFIRMATION_CHANNEL_LABEL: Record<EnsConfirmationVia, string> = {
    PUSH: 'Push',
    INTERNAL_CALL: 'Internal call',
    SMS: 'SMS',
    PSTN: 'Phone call',
    ADMIN_OVERRIDE: 'Admin override',
};

export const getRecipientConfirmationChannelLabel = (
    recipient: Pick<EnsRecipient, 'status' | 'confirmedVia'>,
): string | null => recipient.status === 'CONFIRMED' && recipient.confirmedVia != null
    ? CONFIRMATION_CHANNEL_LABEL[recipient.confirmedVia]
    : null;
